import { Emoji, FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'

import highlightEditMenu from 'assets/images/homepage/callout_main/edit-menu-highlight.webp'
import moderatorGraphic from 'assets/images/homepage/callout_main/lets-go-graphic.webp'
import textOutline from 'assets/images/homepage/callout_main/outline-blue.webp'
import { MLPDownloadAppCTA } from 'components/marketing_landing_page'
import { useScroll, useTransform, motion } from 'framer-motion'
import { useRef } from 'react'

export const MLPBookCalloutText = () => {
  const { colors, mediaQueries } = useTheme()
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['10% end', 'start center'],
  })

  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [0, 0, 1])
  const highlightY = useTransform(scrollYProgress, [0, 1], [100, 0])
  const moderatorY = useTransform(scrollYProgress, [0, 1], [200, 0])
  const emojiY = useTransform(scrollYProgress, [0, 1], [50, 0])

  return (
    <FlexBox
      className={css`
        position: relative;
        gap: max(1.389vw, 16px);
        ${mediaQueries.desktop} {
          gap: 24px;
        }
      `}
      flexDirection="column"
      alignItems="center"
      gap="24px"
      color={colors.uiGraphite}
      ref={ref}
    >
      <motion.img
        style={{ opacity, y: highlightY }}
        className={css`
          display: none;
          ${mediaQueries.mobileL} {
            display: block;
            width: 100px;
            position: absolute;
            inset: -64px 34px auto auto;
          }
          ${mediaQueries.tablet} {
            inset: -64px 68px auto auto;
          }
        `}
        src={highlightEditMenu}
        alt="highlight edit menu"
      />
      <motion.img
        style={{ opacity, y: moderatorY }}
        className={css`
          display: none;
          ${mediaQueries.mobileL} {
            display: block;
            width: 64px;
            position: absolute;
            inset: auto -14px -34px auto;
          }
          ${mediaQueries.tablet} {
            width: 86px;
            inset: auto -14px -54px auto;
          }
          ${mediaQueries.desktop} {
            width: 106px;
            inset: 40px -126px auto auto;
          }
        `}
        src={moderatorGraphic}
        alt="club moderator graphic"
      />
      <motion.div
        style={{ opacity, y: emojiY }}
        className={css`
          display: none;
          ${mediaQueries.mobileL} {
            display: block;
            position: absolute;
            inset: 70% auto auto 0;
            transform: translateY(-50%);
            width: 32px;
            height: 32px;
          }
          ${mediaQueries.tablet} {
            inset: 80% auto auto 0;
            width: 44px;
            height: 44px;
          }
          ${mediaQueries.desktop} {
            inset: 55% auto auto -50px;
            transform: translateY(-50%);
          }
        `}
      >
        <Emoji
          className={css`
            width: 100%;
            height: 100%;
          `}
          emoji="😍"
        />
      </motion.div>
      <Text
        className={css`
          max-width: max(43.403vw, 336px);
          ${mediaQueries.desktop} {
            max-width: 500px;
          }
        `}
        tag="h2"
        type="header"
        align="center"
        custom={{
          fontSize: '36px',
          lineHeight: '36px',
          letterSpacing: '-0.5px',
          [mediaQueries.mobileL]: {
            fontSize: '4.861vw',
            lineHeight: '4.861vw',
          },
          [mediaQueries.desktop]: {
            fontSize: '56px',
            lineHeight: '56px',
          },
        }}
      >
        A new kind of digital
        <br />
        <span
          className={css`
            position: relative;
          `}
        >
          reading
          <img
            className={css`
              display: block;
              width: 130%;
              position: absolute;
              inset: 50% auto auto 50%;
              transform: translate(-50%, -50%);
            `}
            src={textOutline}
            alt="future text outline"
          />
        </span>
        &nbsp; experience
      </Text>
      <Text
        className={css`
          max-width: max(38.194vw, 274px);
          ${mediaQueries.desktop} {
            max-width: 440px;
          }
        `}
        type="body"
        align="center"
        color={colors.uiGraphite}
        custom={{
          fontSize: 'max(1.563vw, 14px)',
          lineHeight: 'max(2.083vw, 20px)',
          letterSpacing: '-0.2px',
          [mediaQueries.desktop]: {
            fontSize: '18px',
            lineHeight: '24px',
            letterSpacing: '-0.3px',
          },
        }}
      >
        Bring books to life with interactive features designed to make reading
        more social, immersive, and fun.
      </Text>
      <MLPDownloadAppCTA
        buttonStyles={css`
          background-color: ${colors.uiBlueUltraLight};
          border-color: ${colors.uiBlueUltraLight};
          color: ${colors.uiGraphite};
          &:hover {
            background-color: ${colors.uiBlueExtraLight};
            border-color: ${colors.uiBlueExtraLight};
            color: ${colors.uiGraphite};
          }
        `}
      />
    </FlexBox>
  )
}
